import type { CyclicTabbingRefs } from './types'
import { getSiteFeatureBoundRefProvider } from '../../utils/refProvider'

const featureName = 'cyclicTabbing'
const cyclicTabbingSiteRefProvider = getSiteFeatureBoundRefProvider(featureName)

const cyclicTabbingRefs: CyclicTabbingRefs = {
	enableCyclicTabbing: () => cyclicTabbingSiteRefProvider(['enableCyclicTabbing']),
	disableCyclicTabbing: () => cyclicTabbingSiteRefProvider(['disableCyclicTabbing']),
}
export { cyclicTabbingRefs }
